export default {"src":"/evde-internet/_next/static/media/image-m.7b43b4ed.svg","height":257,"width":451};